import FJActionConstant from "../../constant/FJActionConstant";

const initState = {
  loadingFonts: [],
}

export default function (state = initState, action) {
  switch (action.type) {
    case FJActionConstant.SET_LOADING_FONT: {
      return {
        ...state,
        loadingFonts: action.loadingFonts,
      }
    }
    default:
      return state;
  }
}